import { apiSlice } from "../../app/api/apiSlice";

export const getLoanDocumentApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getLoanDocument: builder.mutation({
			query: ({ loanGuid, documentId }) => ({
				url: `/api/v1/loan/document/${encodeURIComponent(
					loanGuid ?? ""
				)}/${encodeURIComponent(documentId ?? "")}/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetLoanDocumentMutation } = getLoanDocumentApiSlice;
